<!-- AI assisted development -->
<div class="modal d-block">
  <div class="modal-dialog consolidated-subs-modal-dialog modal-dialog-centered">
    <div class="modal-content" style="border-top-width: 0px !important; border-bottom-width: 0px !important;">

      <div class="modal-header consolidated-subs-modal-header">
        <h5 class="modal-title mb-0">Consolidated Substitutions #{{ orderSourceKey }}</h5>
        <button type="button" class="close" aria-label="Close" [disabled]="isSubmitting" (click)="dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body consolidated-subs-modal-body">
        <div class="consolidated-subs-meta mb-3" *ngIf="consolidatedSubs">
          <span *ngIf="consolidatedSubs.customerName"><strong>Customer:</strong> {{ consolidatedSubs.customerName }}</span>
          <span *ngIf="consolidatedSubs.customerPhone"><strong>Phone:</strong> {{ consolidatedSubs.customerPhone }}</span>
        </div>

        <div class="consolidated-subs-section mb-4" *ngIf="substitutionRows.length > 0">
          <h5 class="section-title text-success">Substitutions</h5>
          <div class="consolidated-subs-table-wrapper consolidated-subs-left-aligned-wrapper widget-shadow">
            <table class="table table-hover consolidated-subs-table consolidated-subs-left-aligned-table mb-0">
              <thead class="bg-lighter-green">
                <tr>
                  <th class="text-center">Decision</th>
                  <th>Original Item</th>
                  <th>Original Qty/Weight</th>
                  <th>Substituted Item</th>
                  <th>Substituted UPC</th>
                  <th>Substituted Qty/Weight</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of substitutionRows">
                  <td class="text-center decision-cell">
                    <button type="button"
                            class="btn btn-sm"
                            [ngClass]="isDecisionSelected(row, 'accept') ? 'btn-success' : 'btn-outline-success'"
                            (click)="setDecision(row, 'accept')">
                      Accept
                    </button>
                    <button type="button"
                            class="btn btn-sm ml-1"
                            [ngClass]="isDecisionSelected(row, 'reject') ? 'btn-danger' : 'btn-outline-danger'"
                            (click)="setDecision(row, 'reject')">
                      Reject
                    </button>
                  </td>
                  <td>{{ row.originalItem?.description }}</td>                  
                  <td>{{ row.originalItem ? formatQuantity(row.originalItem) : '' }}</td>
                  <td>{{ row.item.description }}</td>                  
                  <td>{{ row.item.upc }}</td>
                  <td>{{ formatQuantity(row.item) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="consolidated-subs-section mb-4" *ngIf="nonOriginalRows.length > 0">
          <h5 class="section-title text-success">Non-Original Order Items</h5>
          <div class="consolidated-subs-table-wrapper consolidated-subs-left-aligned-wrapper widget-shadow">
            <table class="table table-hover consolidated-subs-table consolidated-subs-left-aligned-table mb-0">
              <thead class="bg-lighter-green">
                <tr>
                  <th class="text-center">Decision</th>
                  <th>Item</th>
                  <th>UPC</th>
                  <th>Qty/Weight</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of nonOriginalRows">
                  <td class="text-center decision-cell">
                    <button type="button"
                            class="btn btn-sm"
                            [ngClass]="isDecisionSelected(row, 'accept') ? 'btn-success' : 'btn-outline-success'"
                            (click)="setDecision(row, 'accept')">
                      Accept
                    </button>
                    <button type="button"
                            class="btn btn-sm ml-1"
                            [ngClass]="isDecisionSelected(row, 'reject') ? 'btn-danger' : 'btn-outline-danger'"
                            (click)="setDecision(row, 'reject')">
                      Reject
                    </button>
                  </td>
                  <td>{{ row.item.description }}</td>
                  <td>{{ row.item.upc }}</td>
                  <td>{{ formatQuantity(row.item) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="consolidated-subs-empty widget-shadow p-4 text-center" *ngIf="allRows.length === 0">
          No consolidated substitution items found for this order.
        </div>

        <div class="consolidated-subs-status text-muted" *ngIf="allRows.length > 0 && !allDecisionsMade">
          Accept or reject each item to enable submit.
        </div>
        <div class="consolidated-subs-status text-success" *ngIf="allRows.length > 0 && allDecisionsMade && !isSubmitting">
          All items reviewed. Ready to submit.
        </div>
        <div class="consolidated-subs-status text-muted" *ngIf="isSubmitting">
          <i class="fa fa-spinner fa-spin"></i> Submitting consolidated substitutions...
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [disabled]="isSubmitting" (click)="dismiss()">Cancel</button>
        <button type="button"
                class="btn btn-success consolidated-subs-submit-btn"
                *ngIf="allRows.length > 0"
                [disabled]="!canSubmit"
                (click)="submit()">
          <i *ngIf="isSubmitting" class="fa fa-spinner fa-spin"></i>
          <span *ngIf="isSubmitting">&nbsp;Submitting...</span>
          <span *ngIf="!isSubmitting">Submit</span>
        </button>
      </div>
    </div>
  </div>
</div>
